import { api } from "../helpers";

export const getSeasonalUniquePlayers = (param, token) => {
	return api(
		`/dashboard/seasonal-unique-users`,
		"GET",
		undefined,
		param,
		token
	);
};
export const getList = (payload, token) =>
	api("/dashboard", "GET", undefined, undefined, token);

export const changeUserChart = (params, token) => {
	const duration = {
		duration: params,
	};
	return api("/dashboard/users", "GET", undefined, duration, token);
};

export const changeOnlineTourChart = (params, token) =>
	api(
		"/dashboard/online-tours",
		"GET",
		undefined,
		{ duration: params },
		token
	);

export const changeOfflineTourChart = (params, token) =>
	api(
		"/dashboard/offline-tours",
		"GET",
		undefined,
		{ duration: params },
		token
	);
